<template>
  <v-autocomplete
    v-model="myValue"
    :color="color"
    :item-color="itemColor"
    :label="label"
    :items="items"
    :search-input.sync="searchInput"
    :loading="loading"
    :placeholder="placeholder"
    :no-data-text="noDataText"
    item-text="value"
    item-value="value"
    return-object
    :hide-details="hideDetails"
    hide-selected
    :outlined="outlined"
    :disabled="disabled"
    :height="46"
    chips
    :rules="rules"
    @focus="focus"
    @blur="blur"
    @change="$emit('change', myValue)"
  >
    <template v-slot:selection="data">
      <v-chip color="#f5f5f5" :close="close" @click:close="remove">
        <v-avatar left>
          <v-img :src="data.item.icon || default_icon" />
        </v-avatar>
        <span style="font-weight: 300; font-size: 12px;">
          {{ data.item.name }}
        </span>
      </v-chip>
    </template>
    <template v-slot:item="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-item-content v-text="data.item" />
      </template>
      <template v-else>
        <v-list-item-avatar size="24">
          <img :src="data.item.icon || default_icon" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            style="font-size: 12px;height: 12px;line-height: 14px;"
          >
            {{ data.item.name }}
          </v-list-item-title>
          <v-list-item-title
            style="font-size: 12px;height: 12px;line-height: 14px;color: grey"
          >
            {{ data.item.email }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import callapi from "@/functions/ajax";
export default {
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        gid: null,
        email: null,
        name: null,
        icon: null
      })
    },
    label: {
      type: String,
      default: ""
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: "primary"
    },
    itemColor: {
      type: String,
      default: "primary"
    },
    placeholder: {
      type: String,
      default: " "
    },
    noDataText: {
      type: String,
      default: "Please input"
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    close: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      default_icon: require("@/assets/avatar.png"),
      gapi: null,
      loading: false,
      myValue: {
        value: "",
        gid: "",
        email: "",
        name: "",
        icon: "",
        obj: {}
      },
      searchInput: null,
      items: []
    };
  },
  computed: {
    outValue() {
      return this.myValue
        ? {
            gid: this.myValue.gid || "",
            email: this.myValue.email || "",
            name: this.myValue.name || "",
            icon: this.myValue.icon || ""
          }
        : {
            gid: "",
            email: "",
            name: "",
            icon: ""
          };
    }
  },
  watch: {
    value: {
      deep: true,
      handler(val, oVal) {
        this.setMyValue(val);
        console.log(oVal);
      }
    },
    searchInput: {
      deep: true,
      async handler(val, oVal) {
        console.log(oVal);
        let result = [];
        if (val && val.length > 5 && val === this.searchInput) {
          try {
            this.loading = true;
            const data = {
              key: val.toString().trim()
            };
            const response = await callapi(
              "post",
              "distribution",
              "get_userList",
              data
            );
            // console.log(response);
            if (response.status === 200) {
              result = response.data || [];
            }
          } catch (e) {
            // console.log(e);
          }
        }
        if (val === this.searchInput) {
          this.items = result
            // .filter((el, i) => i < 20)
            .map(el => ({
              value: el.id + ";" + el.name.fullName + ";" + el.primaryEmail,
              gid: el.id,
              email: el.primaryEmail,
              name: el.name.fullName,
              icon: el.thumbnailPhotoUrl || null,
              obj: el
            }));
        }
        this.loading = false;
        if (this.myValue && this.myValue.name) this.items.push(this.myValue);
      }
    }
  },
  beforeMount() {
    this.setMyValue(this.value);
  },
  methods: {
    async getList(key) {
      const data = {
        key: key
      };
      let userInfo = await callapi(
        "post",
        "distribution",
        "get_userList",
        data
      ).then(res => {
        if (res.status === 200) {
          // console.log(res.data);
          return res.data;
        }
      });
      return userInfo;
    },
    setMyValue(val) {
      try {
        if (
          val.gid !== this.myValue.gid ||
          val.email !== this.myValue.email ||
          val.name !== this.myValue.name ||
          val.icon !== this.myValue.icon
        ) {
          this.myValue = {
            value: val.gid + ";" + val.name + ";" + val.email || "",
            gid: val.gid || "",
            email: val.email || "",
            name: val.name || "",
            icon: val.icon || ""
          };
          this.searchInput = val.email || "";
        }
      } catch (e) {
        // console.log(e);
      }
    },
    remove() {
      this.items = [];
      console.log(this.myValue);
      this.myValue = null;
      this.$emit("change", this.myValue);
      console.log(this.myValue);
    },
    focus(val) {
      this.$emit("focus", val);
    },
    blur(val) {
      this.$emit("blur", val);
    }
  }
};
</script>

<style></style>
